import * as React from 'react';
import { useDarkMode } from 'usehooks-ts';
import styled from 'styled-components';

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 3rem;
  padding: 2rem var(--padding-x-10) 2rem;
`;

const StyledLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100px;
  min-height: 50px;

  svg {
    min-height: 50px;
    min-width: 100%;
    max-width: 245px;
  }

  * {
    fill: ${({ darkMode }) => (darkMode ? 'white' : 'var(--navy)')};
  }
`;

export default function Logos(props) {
  const { isDarkMode } = useDarkMode();
  return (
    <LogoContainer>
      {props.logos.map((logo) => (
        <StyledLogo
          key={logo.id}
          title={logo.name}
          darkMode={isDarkMode}
          height={logo.height}
        >
          <logo.LogoComponent alt={logo.alt} />
        </StyledLogo>
      ))}
    </LogoContainer>
  );
}
